import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormGroup, ControlLabel } from 'react-bootstrap';

function TemplateNameModal({ data }) {
  const { value, onChange, placeholder } = data || {};
  const [localValue, setLocalValue] = useState(value || '');

  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  const handleChange = e => {
    const next = e.target.value;

    setLocalValue(next);

    if (onChange) {
      onChange(next);
    }
  };

  return (
    <form>
      <FormGroup>
        <ControlLabel>Name</ControlLabel>
        <FormControl
          type="text"
          value={localValue}
          placeholder={placeholder || 'Enter a name'}
          onChange={handleChange}
        />
      </FormGroup>
    </form>
  );
}

TemplateNameModal.propTypes = {
  data: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
  }),
};

TemplateNameModal.defaultProps = {
  data: null,
};

export default TemplateNameModal;
